var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAkamai = function SvgAkamai(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 153.5 166.8",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "akamai_svg__clippath"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2820.9-213.1H610.8v4441h-3431.7z",
    style: {
      fill: "none"
    }
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".akamai_svg__cls-1{fill:#09c}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "akamai_svg__svg834"
  }, /*#__PURE__*/React.createElement("g", {
    id: "akamai_svg__g842"
  }, /*#__PURE__*/React.createElement("g", {
    id: "akamai_svg__g1518"
  }, /*#__PURE__*/React.createElement("g", {
    id: "akamai_svg__g1557"
  }, /*#__PURE__*/React.createElement("g", {
    id: "akamai_svg__g1402"
  }, /*#__PURE__*/React.createElement("path", {
    id: "akamai_svg__path1404",
    d: "M84.7 163.1c-34.4-10.4-59.3-42.2-59.3-79.7S50.9 13.5 85.7 3.3C89.3 2.2 88.4 0 84 0 37.7 0 0 37.4 0 83.4s37.7 83.4 84 83.4c4.4 0 4.6-2.5.7-3.7",
    className: "akamai_svg__cls-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "akamai_svg__g1406"
  }, /*#__PURE__*/React.createElement("path", {
    id: "akamai_svg__path1408",
    d: "M41.4 102.8c-.3-2.2-.4-4.5-.4-6.7 0-36.6 29.6-66.2 66.2-66.2s44.9 15.5 46.2 14.4c1.5-1.1-12.6-31.7-53.1-31.7S34.1 42.2 34.1 78.7s1.6 16.5 4.5 23.9c1.2 3.2 3 3.2 2.8.1",
    className: "akamai_svg__cls-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "akamai_svg__g1410"
  }, /*#__PURE__*/React.createElement("path", {
    id: "akamai_svg__path1412",
    d: "M69.1 55.1c17.2-7.5 38.8-7.8 60.1-.3 14.3 5 22.6 12.2 23.3 11.8 1.2-.5-8.3-15.5-25.4-21.9-20.6-7.8-42.8-3.7-58.9 9-1.9 1.5-1.2 2.4.9 1.5",
    className: "akamai_svg__cls-1"
  }))))))));
};
export default SvgAkamai;